import BGPH1 from "../../assets/images/backgrounds/AboutUs1.png";
import { Helmet } from "react-helmet";
import { Link, useLocation } from "react-router-dom";

const Privacy = () => {
  const location = useLocation();
  const path = location.pathname;
  return (
    <>
      <Helmet>
        <title>Privacy Policy - Addon Broker</title>
        <meta charset="UTF-8" />
        <meta
          name="description"
          content="Addon Brokers Privacy Policy - Learn how we collect, use, and protect your personal information in compliance with Australian privacy laws."
        />
        <link rel="canonical" href={path} />
      </Helmet>

      <div className="stricky-header stricked-menu main-menu">
        <div className="sticky-header__content"></div>
      </div>

      <section className="page-header">
        <div
          className="page-header__bg"
          style={{ backgroundColor: "#005257" }}
        ></div>
        <div className="container">
          <ul className="thm-breadcrumb list-unstyled">
            {/* <li><Link to="/">Home</Link></li> */}
            <li>
              <span>Privacy Policy</span>
            </li>
          </ul>
          <h2>Privacy Policy</h2>
        </div>
      </section>

      <section className="about-two pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="about-two__content">
                <p className="about-two__text" style={{ marginTop: "-40px", textAlign: "justify" }}>
                  Addon Brokers ("we", "us", "our") is committed to protecting
                  your privacy. This Privacy Policy explains how we collect,
                  use, disclose, and protect your personal information in
                  compliance with the Privacy Act 1988 (Cth) and the Australian
                  Privacy Principles (APPs).
                </p>

                <div className="block-title text-left mt-50">
                  <h3
                    className="block-title__title"
                    style={{ fontSize: "24px", textAlign: "justify" }}
                  >
                    1. Information We Collect
                  </h3>
                </div>
                <p className="about-two__text" style={{fontWeight: "bold", textAlign: "justify"}}>We may collect:</p>
                <ul className="list-unstyled ml-0 about-two__list">
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>Your name,
                    address, contact details
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>Date of birth,
                    marital status, dependents
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>Employment and
                    income details
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>Financial
                    information (assets, liabilities, credit history)
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>Identification
                    documents required under law
                  </li>
                </ul>

                <div className="block-title text-left mt-50">
                  <h3
                    className="block-title__title"
                    style={{ fontSize: "24px", textAlign: "justify" }}
                  >
                    2. How We Collect Information
                  </h3>
                </div>
                <p className="about-two__text" style={{fontWeight: "bold", textAlign: "justify"}}>
                  We collect information when you:
                </p>
                <ul className="list-unstyled ml-0 about-two__list">
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>Complete forms
                    on our website
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>Make enquiries
                    via phone, email, or in person
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>Provide
                    documents for loan applications
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>Consent to
                    information from third parties (credit agencies, lenders)
                  </li>
                </ul>

                <div className="block-title text-left mt-50">
                  <h3
                    className="block-title__title"
                    style={{ fontSize: "24px", textAlign: "justify" }}
                  >
                    3. Why We Collect Information
                  </h3>
                </div>
                <p className="about-two__text" style={{fontWeight: "bold", textAlign: "justify"}}>We use your information to:</p>
                <ul className="list-unstyled ml-0 about-two__list">
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>Assess loan
                    eligibility
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>Provide mortgage
                    broking services
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>Communicate with
                    you
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>Meet legal and
                    regulatory obligations
                  </li>
                </ul>

                <div className="block-title text-left mt-50">
                  <h3
                    className="block-title__title"
                    style={{ fontSize: "24px", textAlign: "justify" }}
                  >
                    4. Disclosure
                  </h3>
                </div>
                <p className="about-two__text" style={{fontWeight: "bold", textAlign: "justify"}}>
                  We may disclose your information to:
                </p>
                <ul className="list-unstyled ml-0 about-two__list">
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>Lenders,
                    mortgage insurers, credit reporting agencies
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>IT and
                    compliance service providers
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>Regulators and
                    government authorities
                  </li>
                </ul>
                <p className="about-two__text" style={{ marginTop: "20px",textAlign: "justify" }}>
                  <strong>We will never sell your personal information.</strong>
                </p>

                <div className="block-title text-left mt-50">
                  <h3
                    className="block-title__title"
                    style={{ fontSize: "24px", textAlign: "justify" }}
                  >
                    5. Security
                  </h3>
                </div>
                <p className="about-two__text" style={{ textAlign: "justify" }}>
                  We take reasonable steps to protect your data from loss,
                  misuse, or unauthorised access.
                </p>

                <div className="block-title text-left mt-50">
                  <h3
                    className="block-title__title"
                    style={{ fontSize: "24px", textAlign: "justify" }}
                  >
                    6. Access & Correction
                  </h3>
                </div>
                <p className="about-two__text" style={{ textAlign: "justify" }}>
                  You may request access to or correction of your personal
                  information by contacting us.
                </p>

                <div className="block-title text-left mt-50">
                  <h3
                    className="block-title__title"
                    style={{ fontSize: "24px", textAlign: "justify" }}
                  >
                    7. Cookies & Website Data
                  </h3>
                </div>
                <p className="about-two__text" style={{ textAlign: "justify", textAlign: "justify" }}>
                  We may use cookies and analytics to improve website
                  performance. You can disable cookies in your browser.
                </p>

                <div className="block-title text-left mt-50" >
                  <h3
                    className="block-title__title"
                    style={{ fontSize: "24px", textAlign: "justify" }}
                  >
                    8. Contact Us
                  </h3>
                </div>
                <p className="about-two__text" style={{ textAlign: "justify" }}>
                  <strong>Addon Brokers</strong>
                </p>
                <p className="about-two__text" style={{ marginTop: "7px", textAlign: "justify" }}>
                  Email:{" "}
                  <a href="mailto:info@addonbrokers.com.au">
                    info@addonbrokers.com.au
                  </a>
                </p>
                <p className="about-two__text" style={{ marginTop: "2px", textAlign: "justify" }}>
                  Phone: <a href="tel:1300755626">1300 755 626</a>
                </p>
                <p className="about-two__text" style={{ marginTop: "2px", textAlign: "justify" }}>
                  Address: 5/42-52, Thomas Street, Dandenong, VIC 3175.
                </p>
                <p className="about-two__text" style={{ marginTop: "20px", textAlign: "justify" }}>
                  If you are not satisfied with our response, you may contact
                  the Office of the Australian Information Commissioner (OAIC)
                  at{" "}
                  <a
                    href="https://www.oaic.gov.au"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    www.oaic.gov.au
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Privacy;
